<script>

import {symbol_by_code} from "./currencies.js";

export default {
  name: "product-table-default",
  props: {
    items: Array,
    cart: Object,
  },
  data() {
    return {
      discount: false,
      c_symbol: ''  ,
    }
  },
  mounted() {
    this.c_symbol = symbol_by_code(this.cart.currency_code)
  },
  methods:{
    zaokrouhleni(cs){
      console.log("zaokrouhlit", cs, this.cart.currency_code)
      const c= parseFloat(cs)
      if (this.cart.currency_code=='EUR'){
          return Math.round(c*100)/100
      }
      return Math.round(c)
    },
    perioda(m){
      if (m==1) return 'měsíčně'
      if (m==3) return 'čtvrtletně'
      if (m==6) return 'půlročně'
      if (m==12) return 'ročně'
    },
    changeProduct(it){
      this.$emit('changeProduct', it)
    },
    hasSubscription(){
      for(let i in this.items){
        if (this.items[i].months>1){
          return true
        }
      }
      return false
    }
  },

  watch: {
    cart: {
      handler: function (val) {
        this.c_symbol = symbol_by_code(val.currency_code)
        // Zobrazit slevu/poukaz pokud se liší celková a zlevněná cena
        if (parseFloat(val.get_total_price) !== parseFloat(val.get_discounted_price)) {
          this.discount = true
        }
        // Pro multipurpose poukaz: zobrazit i když get_discounted_price == get_total_price
        // (poukaz nesnižuje cenu, jen snižuje částku k úhradě)
        if (val['has_multipurpose_voucher?'] && parseFloat(val.amount_to_pay) < parseFloat(val.get_total_price)) {
          this.discount = true
        }
      },
      deep: true
    },


    items: {
      handler: function (val) {
        for(let i in this.items){
          this.items[i].selected_variant = this.items[i].product.id
          let it = this.items[i]
          if (it.discounted_price!=it.price_with_tax){
            this.discount = true
          }
        }

        this.cart.get_total_price = parseFloat(this.cart.get_total_price)
        this.cart.get_discounted_price = parseFloat(this.cart.get_discounted_price)
        //console.log('ceny,',this.cart.get_total_price , this.cart.get_discounted_price )
      },
      deep: true
    }
  },
}
</script>

<template>
  <table class="item table">
    <thead>
    <tr>
      <th>Produkt</th>
      <th>Typ platby</th>
      <th id="right">Částka</th>
      <th v-if="hasSubscription()">Období</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="it in items">
      <td>{{ it.product.name }}</td>
      <td>{{ it.months > 0 ? 'Předplatné' : 'Jednorázová' }}</td>
      <td id="right">{{ zaokrouhleni(it.price_with_tax) }} {{c_symbol}}</td>
      <td v-if="hasSubscription()">{{perioda(it.months)}}</td>
    </tr>
    <tr v-if="discount">
      <td> </td>
      <td>{{ cart['has_multipurpose_voucher?'] ? 'Úhrada poukazem' : 'Sleva' }}</td>
      <td id="right">- {{ zaokrouhleni(cart['has_multipurpose_voucher?'] ? (cart.get_total_price - cart.amount_to_pay) : (cart.get_total_price - cart.get_discounted_price)) }} {{c_symbol}}  </td>
      <td v-if="hasSubscription()"> </td>
    </tr>
    </tbody>
    <tfoot v-if="discount">
    <tr id="discount-price">
      <td> </td>
      <td> <b>{{ cart['has_multipurpose_voucher?'] ? 'K úhradě' : 'Cena po slevě' }}</b> </td>
      <td id="right"> <b>{{ zaokrouhleni(cart['has_multipurpose_voucher?'] ? cart.amount_to_pay : cart.get_discounted_price) }} {{c_symbol}} </b> </td>
      <td v-if="hasSubscription()"></td>
    </tr>
    </tfoot>
  </table>

</template>

<style scoped>

#right {
  text-align: right;
}

</style>